import styled, { createGlobalStyle } from 'styled-components'

export const TrendChartStyled = createGlobalStyle`
  .price-coin-line--icon{
    width: 16px;
    height: 16px;
    background: red;
  }
`

export const ChartTrendBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
`
